export const isInTeams = () => {
  if (
    (window.parent === window.self && window.nativeInterface) ||
    ['embedded-page-container', 'extension-tab-frame'].includes(window.name)
  ) {
    return true;
  }
  return false;
};
